import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLastMonthsDate, getNextMonthsDate, processCustomCalenderDate } from '@features/crm/utils/helpers';
import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

import { convertDateToLocal } from '@utils/Util';

const CustomCalender = () => {
	const [showDropdown, setShowDropdown] = useState(false);
	const [dates, setDates] = useState({});
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, 'dateRange', 'dateRange');
	const dispatch = useDispatch();
	const dateRangeRef = useRef(false);
	const myRef = useRef(null);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (e) => {
		if (myRef && !myRef.current.contains(e.target)) {
			if (dateRangeRef && dateRangeRef.current === false) {
				setShowDropdown(false);
			}
		}
	};

	useEffect(() => {
		if (inputValue !== undefined) {
			let splitedKey = inputValue.key.split('_');
			setDates({
				startDate: splitedKey[0],
				endDate: splitedKey[1]
			});
		}
	}, [inputValue]);

	const onChangeMonthRange = (e, label) => {
		if (e.startDate && e.endDate) {
			let startDate = convertDateToLocal(e.startDate, 'YYYY-MM-DD');
			let endDate = convertDateToLocal(e.endDate, 'YYYY-MM-DD');
			setDates({
				startDate: startDate,
				endDate: endDate
			});
			let data = processCustomCalenderDate(startDate, endDate, label);
			dispatch(updateTextItemInGlobalFilter(data));
			setShowDropdown(false);
		}
	};

	const renderCalender = () => {
		return (
			<DateRangePickerComponent
				open={() => (dateRangeRef.current = true)}
				close={() => (dateRangeRef.current = false)}
				blur={() => setShowDropdown(false)}
				format="MMM/yyyy"
				start={'Year'}
				depth={'Year'}
				placeholder="Choose a date range"
				change={(e) => (dateRangeRef?.current === true ? onChangeMonthRange(e) : false)}
				value={{
					start: new Date(dates?.startDate),
					end: new Date(dates?.endDate)
				}}
				openOnFocus={true}
				strictMode={true}
			/>
		);
	};

	const handleMonthPeriods = (value, label) => {
		let currentDate = moment().format('YYYY-MM-DD');
		if (Math.sign(value) === 1) {
			let futureDate = getNextMonthsDate(Math.abs(value));
			onChangeMonthRange({ startDate: currentDate, endDate: futureDate }, label);
		} else {
			let prevDate = getLastMonthsDate(Math.abs(value));
			onChangeMonthRange({ startDate: prevDate, endDate: currentDate }, label);
		}
		setShowDropdown(false);
	};

	return (
		<div className="custom-date-filter position-relative" ref={myRef}>
			<div className="select-component">
				<div className="click-box click mb-1" onClick={() => setShowDropdown((prev) => !prev)}>
					<p className="regular-14 ">{inputValue?.label || 'Next 12 Months'}</p>
					<img src={`${process.env.PUBLIC_URL}/icons/calendar-thin.svg`} alt="" />
				</div>
				<div className={`dropdown-box dropdown-menu ${showDropdown ? 'show' : ''}`}>
					<div className="d-flex">
						<div className="custom-date-box w-100">
							<div className="list-items scroll-y-label">
								<div
									className="single-item"
									onClick={() => handleMonthPeriods(-3, 'Last 3 months')}
								>
									<p>Last 3 months</p>
								</div>
								<div
									className="single-item"
									onClick={() => handleMonthPeriods(-6, 'Last 6 months')}
								>
									<p>Last 6 months</p>
								</div>
								<div
									className="single-item"
									onClick={() => handleMonthPeriods(-12, 'Last 12 months')}
								>
									<p>Last 12 months</p>
								</div>
								<div
									className="single-item"
									onClick={() => handleMonthPeriods(3, 'Next 3 months')}
								>
									<p>Next 3 months</p>
								</div>
								<div
									className="single-item"
									onClick={() => handleMonthPeriods(6, 'Next 6 months')}
								>
									<p>Next 6 months</p>
								</div>
								<div
									className="single-item"
									onClick={() => handleMonthPeriods(12, 'Next 12 months')}
								>
									<p>Next 12 months</p>
								</div>
								<div className="single-item">{renderCalender()}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CustomCalender;
